import React from 'react';
import { useTranslation } from '../../../../i18n';

export interface CatchTheTrainHostProps {
  /** e.g. "Catch the train!", "Catch the bus!" */
  themeTitle: string;
  /** Single emoji for the train preview */
  emoji: string;
  /** When true, round ended — hide content for outro. */
  roundEnded?: boolean;
}

/**
 * Host view: shows the theme title and a single emoji preview (what to catch).
 */
export const CatchTheTrainHost: React.FC<CatchTheTrainHostProps> = ({
  themeTitle,
  emoji,
  roundEnded = false,
}) => {
  const { t } = useTranslation();

  if (roundEnded) return null;

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        flex: '1 1 auto',
        minHeight: 0,
        padding: '1rem',
        gap: '2rem',
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <div
          className="bonus-host-glow-text"
          style={{
            fontSize: 'clamp(1.2rem, 2.5vw, 1.8rem)',
            fontWeight: 700,
            marginBottom: '0.5rem',
          }}
        >
          {themeTitle}
        </div>
        <div
          className="bonus-host-glow-text--muted"
          style={{
            fontSize: 'clamp(0.95rem, 2vw, 1.25rem)',
            fontWeight: 500,
          }}
        >
          {t('bonus.catchTrainTagline')}
        </div>
      </div>

      {/* Single emoji preview (what to catch) */}
      <div
        style={{
          padding: '1.5rem 2rem',
          backgroundColor: 'rgba(52, 211, 153, 0.12)',
          borderRadius: '20px',
          border: '4px solid rgba(52, 211, 153, 0.4)',
          display: 'inline-block',
        }}
      >
        <div
          style={{
            fontSize: 'clamp(4rem, 12vw, 8rem)',
            lineHeight: 1.2,
            letterSpacing: '0.05em',
          }}
        >
          {emoji}
        </div>
      </div>
    </div>
  );
};
